import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType,
} from "common/NewLook/tokens.ts";

/**
 * New look: the public bot's one action ("Copy Bot") on cards and rows. A
 * quiet control — brand blue text on a hairline, filled only on hover — since
 * the card or row itself opens the bot too.
 */
export const QuietButton = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  border: none;
  border-radius: ${NEW_LOOK_RADIUS.control}px;
  background: ${(p) => getNewLookTokens(p.theme).panel};
  box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
  ${newLookType.label};
  color: ${(p) => getNewLookTokens(p.theme).accent};
  font-family: inherit;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 120ms, box-shadow 120ms;
  &:hover {
    background: ${(p) => getNewLookTokens(p.theme).rowHover};
    box-shadow: inset 0 0 0 1px
      ${(p) => getNewLookTokens(p.theme).hairlineStrong};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => getNewLookTokens(p.theme).focus};
    outline-offset: 1px;
  }
`;

/**
 * New look, bot form: copying a public bot is the list's main action, so its
 * button is tinted brand blue (filled on hover) — clearly a button, while the
 * form's own primary action stays the one solid blue.
 */
export const CopyBotButton = styled(QuietButton)`
  background: ${(p) => hexToRGB(getNewLookTokens(p.theme).accent, 0.1)};
  box-shadow: none;
  font-weight: 520;
  &:hover {
    background: ${(p) => getNewLookTokens(p.theme).accent};
    box-shadow: none;
    color: #ffffff;
  }
`;

/** The bot's name: the card and row title. */
export const BotName = styled.div`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${newLookType.panelTitle};
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;

/** What it trades and where, under the name: "BTC/USDT · Binance". */
export const BotSub = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  ${newLookType.meta};
  color: ${(p) => getNewLookTokens(p.theme).secondary};
`;
export const BotSubPart = styled.span`
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  &:first-child {
    flex: none;
  }
`;
export const BotSubDot = styled.span`
  flex: none;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.6;
`;
